import React, { useEffect, useState } from "react";
import Styles from "./MakerChecker.module.css";
import {
  getParentPaymentDetails,
  getParentPaymentDetailsHistory,
} from "../../../Services/GNA/GetData";
import { useSelector } from "react-redux";
import { ErrorMessage } from "../../../commons/Toast/ErrorMessage";
import { convertDate, formatDateType } from "../../../commons/FormatDate";
import Settlement from "../../Modals/Schedule/Settlement/Settlement";
import { ReactComponent as ViewIcon } from "../../../assets/images/view.svg";
import ViewDoc from "../../Modals/ConGen/ViewDoc/ViewDoc";

const MakerChecker = ({ type }) => {
  const role = useSelector((state) => state?.persistedReducer?.userType);
  const userId = useSelector(
    (state) => state?.persistedReducer?.user?.user?.userId,
  );
  const [settlement, setSettlement] = useState({
    status: false,
    id: "",
    data: "",
  });
  const [data, setData] = useState(null);
  const [viewDocModalOpen, setViewDocModalOpen] = useState(false);
  const [viewDocConnectionId, setViewDocConnectionId] = useState(null);

  useEffect(() => {
    if (type === "HISTORY") {
      handleHistory();
    } else {
      handleFetchData();
    }
  }, []);

  const handleFetchData = async () => {
    let res = await getParentPaymentDetails({
      role: role,
      userId: userId,
    });
    if (res?.data?.code === 200) {
      setData(res?.data?.data?.page);
    } else {
      ErrorMessage(
        res?.data?.message || res?.data?.error || "Failed to fetch data",
      );
    }
  };

  const handleHistory = async (id) => {
    let history = await getParentPaymentDetailsHistory({
      role: role,
      userId: userId,
    });
    if (history?.data?.code === 200) {
      let historyData = history?.data?.data?.page || [];

      setData(historyData);
    } else {
      ErrorMessage(
        history?.data?.message ||
          history?.data?.error ||
          "Failed to fetch history data",
      );
    }
  };
  const handleOpenViewDoc = (connectionId, counterparty) => {
    setViewDocConnectionId(connectionId);
    // setActiveViewCounterparty(counterparty);
    setViewDocModalOpen(true);
  };

  return (
    <>
      {settlement.status && (
        <Settlement
          open={settlement?.status}
          handleClose={() => setSettlement({ status: false, id: "", data: "" })}
          id={settlement?.id}
          data={settlement?.data}
          admin={true}
          renderScheuleData={handleFetchData}
          type={type}
        />
      )}

      {viewDocModalOpen && (
        <ViewDoc
          open={viewDocModalOpen}
          handleClose={() => setViewDocModalOpen(false)}
          connectionId={viewDocConnectionId}
          viewDocData={data}
        />
      )}
      <div className={Styles.makerCheckerContainer}>
        <div className="display_flex_row tableHeading">
          <div style={{ width: "10%" }}>Contract ID</div>
          <div style={{ width: "10%" }}>Buyer</div>
          <div style={{ width: "10%" }}>Seller</div>
          <div style={{ width: "20%" }}>Charge Feq.</div>
          <div style={{ width: "20%" }}>Delivery Date</div>
          <div style={{ width: "10%" }}>Delivered Volume (MWh)</div>
          <div style={{ width: "10%" }}>Rate(₹/kWh)</div>
          <div style={{ width: "10%" }}>Status</div>
          <div style={{ width: "10%" }}>View Docs</div>
          <div style={{ width: "10%" }}>Activity</div>
        </div>
        <div className={`scroll_bar_y ${Styles.tableContainer}`}>
          {data && data.length > 0 ? (
            <>
              {data?.map((ele) => {
                return (
                  <div className="display_flex_row tableDetails">
                    <div style={{ width: "10%" }}>
                      {ele?.bilateralContractUniqueId || "-"}
                    </div>

                    <div
                      style={{
                        width: "10%",
                        display: "block", // 'block' is often more reliable for text truncation than 'flex'
                        whiteSpace: "nowrap", // Forces text to stay on one line
                        overflow: "hidden", // Hides the content that spills out
                        textOverflow: "ellipsis", // Adds "..." at the end (e.g., "Uttar Prade...")
                      }}
                    >
                      {ele?.selfCompanyName || "-"}
                    </div>
                    <div
                      style={{
                        width: "10%",
                        display: "block", // 'block' is often more reliable for text truncation than 'flex'
                        whiteSpace: "nowrap", // Forces text to stay on one line
                        overflow: "hidden", // Hides the content that spills out
                        textOverflow: "ellipsis", // Adds "..." at the end (e.g., "Uttar Prade...")
                      }}
                    >
                      {ele?.counterPartyCompanyName || "-"}
                    </div>
                    <div style={{ width: "20%" }}>{ele?.type || "-"}</div>
                    <div style={{ width: "20%" }}>
                      {ele?.fromDate ? convertDate(ele.fromDate) : "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {ele?.deliveredVolume?.toFixed(2) || "-"}
                    </div>
                    <div style={{ width: "10%" }}>
                      {" "}
                      {`${
                        ele?.type === "ONE_TIME"
                          ? "-"
                          : ele?.energyRateType === "FIXED"
                            ? `${ele?.energyRate?.toFixed(2)}`
                            : ele?.energyRateType === "DAM_PLUS"
                              ? `DAM+${ele?.energyRate}`
                              : ele?.energyRateType === "DAM_MINUS"
                                ? `DAM-${ele?.energyRate}`
                                : "-"
                      }`}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      className={
                        (ele?.status === "MAKER" && role === "MAKER") ||
                        ele?.status === "CHECKER" ||
                        role === "CHECKER"
                          ? "pending"
                          : "accepted"
                      }
                    >
                      {ele?.status}
                      {/* {ele?.status === "PAYMENT"
                        ? "Delivered"
                        : (ele?.status === "MAKER" && role === "MAKER") ||
                            (ele?.status === "CHECKER" && role === "CHECKER")
                          ? "Pending"
                          : (ele?.status === "MAKER" && role === "CHECKER") ||
                              (ele?.status === "CHECKER" && role === "MAKER")
                            ? "Verified"
                            : ele?.status === "RECHECK"
                              ? "Recheck"
                              : "-"} */}
                    </div>
                    <div
                      style={{ width: "10%" }}
                      onClick={() =>
                        handleOpenViewDoc(
                          ele?.bilateralContractId,
                          ele?.counterPartyCompanyName,
                        )
                      }
                      className={
                        (ele?.status === "MAKER" && role === "MAKER") ||
                        ele?.status === "CHECKER" ||
                        role === "CHECKER"
                          ? "pending"
                          : "accepted"
                      }
                    >
                      <ViewIcon style={{ width: "15px", height: "15px" }} />
                    </div>
                    <div
                      style={{ width: "10%" }}
                      onClick={() =>
                        setSettlement({
                          status: true,
                          id: ele?.settlementId,
                          data: ele,
                        })
                      }
                      className={`activeButton ${Styles.settlementButton}`}
                    >
                      {role === "MAKER"
                        ? `${
                            ele?.status === "PAYMENT" ||
                            ele?.status === "CHECKER"
                              ? "View"
                              : "Settle"
                          } Transaction`
                        : role === "CHECKER"
                          ? `${
                              ele?.status === "PAYMENT" ? "View" : "Settle"
                            } Transaction`
                          : "View"}
                    </div>
                  </div>
                );
              })}
            </>
          ) : data?.length === 0 ? (
            <div className="pending">No Activity available</div>
          ) : (
            <div className="pending">Loading ....</div>
          )}
        </div>
      </div>
    </>
  );
};

export default MakerChecker;
